<template>
  <div :style="customStyle" class="aretv sedna-transit">
    <div class="widgetLogo">
      <img :src="`/img/are_logo.svg`" />
    </div>
    <div class="widgetTitle">
      TRANSIT TIMES
    </div>
    <div class="date">
      {{formatedDate}}, {{formatedTime.toLowerCase()}} - {{ locationLabel || location }}
    </div>

    <div class="panels-grid">
    <template v-if="dataIsLoaded">
      <TransitItem
        class="grid-item"
        v-for="(journey, idx) in (journeys || destinations)"
        :key="idx"
        :time="journey.travelTime"
        :destinationLabel="journey.label"
      />
    </template>
    <p v-else class="loader">Fetching transit info...</p>
    </div>
  </div>
</template>

<script>
  /**
   * Test using thus URL (Warsaw office + lunch places nearby):
   * http://localhost:8080/transit?location=52.227799,20.992899&destination=52.226307,20.982894%3BByd%C5%82o%20i%20powid%C5%82o&destination=52.235757,20.990526%3BMiss%20Kimchi&destination=52.219454,21.01729%3BTuk%20Tuk&destination=52.232758,21.013509%3BBarnBurger
   */

  import axios from 'axios'
  import TransitItem from './TransitItem'
  const API_KEY = 'n4VvYvkQnxnFZuqmyWGq6Vrnh9BTB_JOEOQt-teMhIM'
  const API_URL = 'https://route.ls.hereapi.com/routing/7.2/calculateroute.json'

  export default {
    name: 'Transit',
    components: { TransitItem },
    props: {
      customStyle: { type: Object, default: () => {} },
      customColor: { type: String, default: '' },
      customBackground: { type: String, default: '' }
    },
    data () {
      return {
        dataIsLoaded: false,
        location: '', // geolocation of the screen/kiosk, e.g. '52.5,13.4'
        locationLabel: '', // custom label for location (if geodecoded one is too long or sth)
        destinations: [], // data decoded from URL query
        journeys: [], // `destinations` data plus journey time taken from transit API
        now: new Date()
      }
    },
    computed:{
      formatedDate() {
        let date = new Date().toLocaleDateString("en-US", {
          day: "numeric",
          month: "long"
        });
        let day = ["st", "nd", "rd", "th"];
        let currentday = new Date().getDate() > 4 ? 3 : new Date().getDate() - 1;
        return date + day[currentday];
      },
      formatedTime() {
        let time = this.now
                .toLocaleString("en-us")
                .split(",")[1]
                .split(":");
        return `${time[0]}:${time[1]}${time[2].split(" ")[1]}`;
      }
    },
    mounted () {
      const queryString = window.location.search // TODO: maybe use $route.params instead?
      const urlParams = new URLSearchParams(queryString)
      this.location = urlParams.get('location')
      this.locationLabel = urlParams.get('locationLabel')

      urlParams.getAll('destination').map((item) => {
        const bits = item.split(';', 2)
        const destination = {
          location: bits[0],
          label: bits[1]
        }
        this.destinations.push(destination)
      })

      const apiRequests = []
      const component = this
      this.destinations.map((destination) => {
        const params = {
          apiKey: API_KEY,
          waypoint0: `geo!${component.location}`,
          waypoint1: `geo!${destination.location}`,
          mode: 'fastest;car;traffic:disabled'
        }
        apiRequests.push(axios.get(`${API_URL}`, { params }).then((response) => {
          const data = response.data.response
          const route = data.route[0]
          const summary = route.summary
          return {
            ...destination,
            travelTime: summary.travelTime, // seconds
            trafficTime: summary.trafficTime, // seconds
            distance: summary.distance // meters
          }
        }))
      })

      Promise.all(apiRequests).then((values) => {
        component.journeys = values
        component.dataIsLoaded = true
      })
    }
  }
</script>

<style>
  .panels-grid{
    display: flex;
  }

  .aretv {
    font-weight: bold;
  }

  @media screen and (max-width: 3839px) {
    .aretv {
      width: 1920px;
      height: 1080px;
    }
    .widgetLogo{
      line-height: 1px;
    }
    .widgetLogo img  {
      max-height: 100%;
      max-width: 100%;
      margin-left:60px;
      margin-top:85px;
      min-height:60px;
    }
    .widgetTitle {
      font-size: 200px;
      height: 200px;
      line-height: 200px;
      margin-top:55px;
      margin-left:50px;
      letter-spacing: 7px;
    }
    .date {
      font-size: 70px;
      height: 70px;
      line-height: 50px;
      font-weight: 600;
      margin-bottom: 155px;
      margin-top:15px;
      margin-left: 50px;
    }

    .panels-grid{
      margin-left:25px;
      padding-left:20px;
      padding-right:20px;
      margin-right:25px;

    }
    .panels-grid .grid-item {
      box-sizing: border-box;
      width: 310px;
      height: 340px;
      border: 1px solid;
      padding: 20px;
    }
  }

  @media screen and (min-width: 3840px) {
    .aretv {
      width: 3840px;
      height: 2160px;
      padding: 190px 170px 140px 170px;
    }

    .widgetLogo {
      height: 120px;
      margin-top: 15px;
      margin-left: 55px;
    }

    .widgetLogo img {
      height: 100%;
    }

    .widgetTitle {
      font-size: 400px;
      height: 440px;
      margin-top:25px;
      margin-bottom: 80px;
      margin-left: 30px;
      line-height: 590px;
      word-spacing: 40px;
      letter-spacing: 11px;
    }

    .date {
      font-size: 140px;
      height: 140px;
      line-height: 110px;
      margin-left: 20px;
      font-weight: 600;
      margin-bottom: 330px;
    }

    .panels-grid{
      margin-left:20px;
      padding-left:10px;
      margin-right: 20px;
      padding-right:10px;
    }

    .panels-grid .grid-item {
      box-sizing: border-box;
      width: 625px;
      height: 685px;
      border: 1px solid;
    }
  }
</style>
